// is base implementation enough? Just an example of how to override
export const isExternalLink = (url) => url.protocol.startsWith('http') && url.origin !== location.origin; // && !url.hostname.includes('cigna.com');
